import gql from "graphql-tag";
import moment from "moment-timezone";
import { apolloClient } from "@/apollo.services";
const checkMonitoringKey = "c1b6011ebadc10242ac120002";

export default class AccountingClientMonitoringServices {
    static getHeaders(
        showFECInfo = false,
        selectedView = "production",
        includeCompanyName = true,
        startDate,
        endDate,
    ) {
        const header = [];
        if (includeCompanyName) {
            header.push({
                title: "Société",
                align: "start",
                sortable: true,
                value: "name",
                width: "140px",
            });
        }
        if (showFECInfo && selectedView === "production") {
            header.push({
                title: "FEC",
                align: "center",
                sortable: false,
                value: "FEC",
                width: "20px",
            });
        }
        if (selectedView === "finalization") {
            header.push(
                {
                    title: "Dossier de révision",
                    align: "center",
                    sortable: false,
                    value: "accountingReviewLayout",
                    width: "900px",
                },
                {
                    title: "Liasse",
                    align: "center",
                    sortable: false,
                    value: "bundle",
                    width: "120px",
                },
            );
        } else {
            let currentDate = this.formatMonth(startDate);
            do {
                header.push({
                    title: currentDate,
                    align: "center",
                    value: currentDate,
                    sortable: false,
                    width: "80px",
                });
                currentDate = this.nextDate(currentDate);
            } while (this.isEndIteration(currentDate, endDate));
        }
        return header;
    }

    static formatMonth(date) {
        const fDate = date.substring(0, 7);
        return fDate;
    }

    static nextDate(date) {
        return moment(date, "YYYY-MM").add(1, "M").format("YYYY-MM");
    }

    static isEndIteration(date, endDate) {
        return moment(date, "YYYY-MM").isSameOrBefore(moment(this.formatMonth(endDate), "YYYY-MM"));
    }

    static async createSet(itemValue, actionType, actionDate, company_id) {
        const data = itemValue || {};

        if (!data[actionType]) {
            data[actionType] = {};
        }
        data[actionType][actionDate] = { auditCheckResult: true };

        await apolloClient.mutate({
            mutation: gql`
                mutation UpsertSetMonitoring(
                    $key: String!
                    $companyId: ID!
                    $data: Json
                    $status: AuditCheckResultStatus!
                    $auditCheckKey: String!
                ) {
                    upsertAuditCheckResult(
                        where: { key: $key }
                        create: {
                            auditCheck: { connect: { key: $auditCheckKey } }
                            company: { connect: { id: $companyId } }
                            key: $key
                            data: $data
                            status: $status
                        }
                        update: { data: $data }
                    ) {
                        id
                    }
                }
            `,
            variables: {
                key: `${actionType}-${company_id}-${actionDate}`,
                companyId: company_id,
                data: data,
                status: "UNKNOWN",
                auditCheckKey: checkMonitoringKey,
            },
        });
        return data;
    }

    // static async createCheck(itemValue, actionType, company_id) {
    //     let data = itemValue || {};

    //     if (!data[actionType]) {
    //         data[actionType] = {};
    //     }
    //     data[actionType].auditCheckResult = true;

    //     await apolloClient.mutate({
    //         mutation: gql`
    //             {
    //                 upsertAuditCheckResult(
    //                     where: { key: $key }
    //                     create: {
    //                         auditCheck: { connect: { key: $checkMonitoringKey } }
    //                         company: { connect: { id: $companyId } }
    //                         key: $key
    //                         data: $data
    //                         status: $status
    //                     }
    //                     update: { data: $data }
    //                 ) {
    //                     id
    //                 }
    //             }
    //         `,
    //         variables: {
    //             key: `${checkMonitoringKey}-${company_id}`,
    //             companyId: company_id,
    //             data: data,
    //             status: "UNKNOWN",
    //         },
    //     });
    //     return data;
    // }
}
